/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-24T15:57:51.839
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-renthousetypetag-'

export default 
{
path: '/rentmanage/renthousetypetag',
name: 'rentmanage-renthousetypetag',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}renthousetypetag-index',

meta:{
...meta,
title: '房源标签'
},

component: () => import('@/pages/rentmanage/renthousetypetag/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}renthousetypetag-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源标签编辑'
},

component: () => import('@/pages/rentmanage/renthousetypetag/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}renthousetypetagdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源标签新增'
},

component: () => import('@/pages/rentmanage/renthousetypetag/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}renthousetypetagView',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源标签详情查看'
},

component: () => import('@/pages/rentmanage/renthousetypetag/detail-view') ,
},
]
};
